import { useCallback } from 'react';
import { useHexBidiFormatter } from '../__internal__';
import { basicColors } from '../__internal__/BasicColorPallete';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-ColorPicker-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useColorPickerA11yInfo = () => {
  const localize = useTextLocalizer();
  const hexBidiFormatter = useHexBidiFormatter();
  return useCallback(props => {
    const swatchColor = props.selectedColor?.color ?? '#000000';
    const colorType = props.selectedColor?.type ?? 'standard';
    const isCustomColor = !basicColors.includes(swatchColor);
    const colorTitle = isCustomColor ? hexBidiFormatter(swatchColor) : `${localize(`color.${swatchColor.slice(1)}.title`)} (${hexBidiFormatter(swatchColor)})`;
    const internalTooltip = swatchColor === '' && colorType === 'nocolor' ? localize(`color.noColor.title`) : colorType === 'automatic' ? localize(`automatic.title`, {
      color: colorTitle
    }) : colorTitle;
    const colorAria = isCustomColor ? swatchColor.split('').join(' ') : `${localize(`color.${swatchColor.slice(1)}.aria`)} (${swatchColor.split('').join(' ')})`;
    const internalAria = swatchColor === '' && colorType === 'nocolor' ? localize(`color.noColor.aria`) : colorType === 'automatic' ? localize(`automatic.aria`, {
      color: colorAria
    }) : colorAria;
    const tooltip = props.localizedPrefix ? `${props.localizedPrefix}${internalTooltip}` : localize(props.readOnly ? 'dropdownSwatch.readOnly.title' : 'dropdownSwatch.title', {
      color: internalTooltip
    });
    const aria = props.localizedPrefix ? `${props.localizedPrefix}${internalAria}` : localize(props.readOnly ? 'dropdownSwatch.readOnly.aria' : 'dropdownSwatch.aria', {
      color: internalAria
    });
    return {
      ariaLabel: props.ariaLabel ?? aria,
      tooltip: props.tooltip ?? tooltip
    };
  }, [hexBidiFormatter, localize]);
};
//# sourceMappingURL=useColorPickerA11yInfo.js.map